export default "__VITE_ASSET__CDL6MbWY__"